import styles from "./Dropdown.module.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useState, useEffect } from "react";
import { library } from '@fortawesome/fontawesome-svg-core'
import PropTypes from 'prop-types';
import { fas } from "@fortawesome/pro-solid-svg-icons";
library.add(fas);

const openIcon = <FontAwesomeIcon icon={["fas", "chevron-down"]} />;
const closeIcon = <FontAwesomeIcon icon={["fas", "chevron-up"]} />;

const Dropdown = ({ options, value, className, onChange, name, ...props }) => {
    const [isListOpen, setIsListOpen] = useState(false);
    const [ddTitle, setDdTitle] = useState(value === undefined ? options[0] : value )

    useEffect(() =>{
        if(value === undefined && props.firstValue !== undefined &&  options.includes(props.firstValue)) {
            setDdTitle(props.firstValue)
        }
    }, [])
    useEffect(() => {
        setDdTitle(value)
      },[value])
    return (
        <div className={[styles.wrapper, className].filter(e => !!e)
            .join(' ')}>
            <input className={styles.hidden} name={name} value={ddTitle} />
            <button
                type="button"
                className={[isListOpen && styles.open, styles.dropdown].filter(e => !!e)
                    .join(' ')}
                onClick={() => { setIsListOpen(!isListOpen); }} {...props}>
                <span
                    className={styles.title}
                >
                    {ddTitle}
                </span>
                <span className={styles.iconContainer}>
                    {isListOpen
                        ? <span className={styles.icon}>{closeIcon}</span>
                        : <span className={styles.icon}>{openIcon}</span>}
                </span>
            </button>
            {isListOpen && (
                <span
                    className={styles.list}
                >
                    {options?.map((title, index) =>
                        <button
                            type="button"
                            className={styles.listItem}
                            key={index}
                            onClick={(e) => {
                                e.preventDefault();
                                setDdTitle(title.toString());
                                setIsListOpen(false);
                                onChange && onChange({ target: { value: title } });
                            }}
                        >
                            {title.toString()}
                        </button>
                    )}
                </span>
            )}
        </div>
    );
}

Dropdown.propTypes = {
    onChange: PropTypes.any.isRequired
}

export default Dropdown;